<template>
  <div class="p-2 sm:p-4 text-lexend overflow-x-hidden min-h-screen bg-gray-50 dark:bg-gray-900/50">
    <!-- Encabezado elegante -->
    <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-4 mb-3 sm:mb-5 mt-1 scroll-reveal">
      <div class="animate-fadeIn w-full sm:w-auto">
        <div class="flex items-center gap-2 mb-1">
          <div class="w-8 h-1 bg-indigo-600 rounded-full"></div>
          <span class="text-[10px] sm:text-xs font-black text-indigo-600 tracking-widest">Panel de Control</span>
        </div>
        <h1 class="text-xl sm:text-3xl font-black text-gray-900 dark:text-white tracking-tight flex items-center flex-wrap gap-2">
          Gestión de Ventas
          <span class="px-2 sm:px-3 py-0.5 bg-indigo-100 dark:bg-indigo-900/40 text-indigo-600 dark:text-indigo-300 text-xs sm:text-sm font-black rounded-lg border border-indigo-200 dark:border-indigo-800">
            {{ ventas.length }}
          </span>
        </h1>
        <p class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400 mt-0.5">Historial de transacciones y cobros</p>
      </div>
      
      <div class="flex items-center gap-2 w-full sm:w-auto">
        <button @click="refreshVentas" :disabled="cargando" class="px-3 sm:px-4 py-2 bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 rounded-xl font-black text-[10px] sm:text-xs tracking-widest transition-all shadow-md flex items-center gap-2 border border-gray-200 dark:border-gray-600 disabled:opacity-50">
          <Icon :icon="cargando ? 'mdi:loading' : 'mdi:refresh'" :class="['text-base sm:text-lg', cargando && 'animate-spin']" />
          <span>Actualizar</span>
        </button>
        <button @click="$router.push('/ventas/nueva')" class="px-3 sm:px-6 py-2 bg-gradient-to-r from-green-500 to-emerald-500 text-white rounded-xl font-black text-[10px] sm:text-xs tracking-widest transition-all shadow-lg shadow-green-200 dark:shadow-none flex items-center gap-2">
          <Icon icon="mdi:plus" class="text-base sm:text-xl" />
          <span class="hidden sm:inline">Nueva Venta</span>
          <span class="sm:hidden">Nueva</span>
        </button>
      </div>
    </div>

    <!-- Panel de Filtros Compacto -->
    <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 mb-3 sm:mb-5 overflow-hidden animate-fadeInUp">
      <div class="p-3 border-b border-gray-100 dark:border-gray-700 flex items-center justify-between bg-gray-50/50 dark:bg-gray-800/50">
        <div class="flex items-center gap-2">
          <Icon icon="mdi:filter-variant" class="text-blue-500 text-lg" />
          <h2 class="text-[10px] sm:text-xs font-bold text-gray-700 dark:text-white uppercase tracking-wider">Filtros de Búsqueda</h2>
          <span v-if="filtrosActivos" class="px-1.5 py-0.5 bg-blue-100 text-blue-600 text-[8px] sm:text-[9px] font-bold rounded uppercase">Activos</span>
        </div>
        <button @click="toggleFiltros" class="text-[9px] sm:text-[10px] font-bold text-blue-600 hover:text-blue-700 flex items-center gap-1 uppercase">
          <Icon :icon="mostrarFiltros ? 'mdi:chevron-up' : 'mdi:chevron-down'" class="text-base" />
          {{ mostrarFiltros ? 'Contraer' : 'Expandir' }}
        </button>
      </div>

      <div v-if="mostrarFiltros" class="p-3 sm:p-4 bg-white dark:bg-gray-800">
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-2 sm:gap-3">
          <div class="sm:col-span-1 lg:col-span-3">
            <label class="block text-[9px] sm:text-[10px] font-bold text-gray-400 uppercase mb-1 ml-1">Factura</label>
            <input v-model="filtro.numeroFactura" type="text" placeholder="FAC-000" class="w-full px-3 py-1.5 bg-gray-50 dark:bg-gray-700/50 border border-gray-200 dark:border-gray-600 rounded-lg text-xs focus:border-blue-500 outline-none transition-all text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-400" @input="filtrarVentas" />
          </div>
          <div class="sm:col-span-1 lg:col-span-3">
            <label class="block text-[9px] sm:text-[10px] font-bold text-gray-400 uppercase mb-1 ml-1">Vendedor</label>
            <select v-model="filtro.idVendedor" class="w-full px-2 py-1.5 bg-gray-50 dark:bg-gray-700/50 border border-gray-200 dark:border-gray-600 rounded-lg text-xs focus:border-blue-500 outline-none cursor-pointer text-gray-900 dark:text-white" @change="filtrarVentas">
              <option value="">Todos los vendedores</option>
              <option v-for="vendedor in vendedoresUnicos" :key="vendedor.idVendedor" :value="vendedor.idVendedor">{{ vendedor.nombreCompleto }}</option>
            </select>
          </div>
          <div class="sm:col-span-2 lg:col-span-4">
            <label class="block text-[9px] sm:text-[10px] font-bold text-gray-400 uppercase mb-1 ml-1">Rango de Fecha</label>
            <div class="flex items-center gap-1">
              <input v-model="filtro.fechaDesde" type="date" class="w-full px-2 py-1.5 bg-gray-50 dark:bg-gray-700/50 border border-gray-200 dark:border-gray-600 rounded-lg text-[10px] focus:border-blue-500 outline-none text-gray-900 dark:text-white" @change="filtrarVentas" />
              <span class="text-gray-300 text-xs">-</span>
              <input v-model="filtro.fechaHasta" type="date" class="w-full px-2 py-1.5 bg-gray-50 dark:bg-gray-700/50 border border-gray-200 dark:border-gray-600 rounded-lg text-[10px] focus:border-blue-500 outline-none text-gray-900 dark:text-white" @change="filtrarVentas" />
            </div>
          </div>
          <div class="sm:col-span-2 lg:col-span-2 flex items-end gap-2">
            <button @click="resetFiltros" class="flex-1 px-3 py-1.5 text-[9px] sm:text-[10px] font-black uppercase text-gray-400 hover:text-gray-600 transition-colors border border-gray-200 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700">Limpiar</button>
            <button @click="aplicarFiltrosRapidos" class="flex-1 px-3 py-1.5 bg-blue-600 text-white rounded-lg text-[9px] sm:text-[10px] font-black uppercase shadow-md hover:bg-blue-700 transition-all flex items-center justify-center gap-1.5">
              <Icon icon="mdi:filter-check" class="text-sm" />
              <span class="hidden sm:inline">Aplicar</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Tabla de ventas -->
    <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-md border border-gray-200 dark:border-gray-700 overflow-hidden animate-fadeInUp delay-100">
      <!-- Vista móvil (cards) -->
      <div class="block sm:hidden">
        <div v-if="cargando" class="p-8 text-center">
          <div class="inline-block animate-spin rounded-full h-8 w-8 border-4 border-blue-500 border-t-transparent"></div>
          <p class="mt-2 text-gray-600 dark:text-gray-400 text-sm">Cargando ventas...</p>
        </div>
        
        <div v-else-if="ventasPaginadas.length === 0" class="p-8 text-center">
          <Icon icon="mdi:file-search-outline" class="text-5xl text-gray-300 mx-auto mb-3" />
          <p class="text-gray-600 dark:text-gray-400 font-bold">No hay ventas</p>
          <button @click="resetFiltros" class="mt-2 text-indigo-600 text-sm hover:underline font-bold">Limpiar filtros</button>
        </div>
        
        <div v-else class="divide-y divide-gray-200 dark:divide-gray-700">
          <div v-for="venta in ventasPaginadas" :key="venta.idVenta" 
               class="p-4 hover:bg-gray-50 dark:hover:bg-gray-700/50 cursor-pointer transition-colors">
            
            <div class="flex justify-between items-start mb-2">
              <div class="flex-1 min-w-0">
                <div class="font-semibold text-blue-600 dark:text-blue-400 truncate flex items-center gap-2 text-sm">
                  {{ venta.numeroFactura }}
                  <span v-if="venta.tipoVenta" 
                        class="px-2 py-0.5 text-[8px] rounded-full whitespace-nowrap font-black"
                        :class="getTipoVentaClasses(venta.tipoVenta)">
                    {{ formatearTipoVentaConCredito(venta.tipoVenta, venta.idTipoCredito) }}
                  </span>
                </div>
                <div class="text-[10px] text-gray-500 dark:text-gray-400 font-bold">{{ formatFecha(venta.fechaVenta) }}</div>
              </div>
            </div>
            
            <div class="grid grid-cols-2 gap-2 mb-2 text-xs">
              <div>
                <span class="text-[9px] text-gray-500 dark:text-gray-400 block uppercase font-bold">Cliente</span>
                <span class="font-bold truncate block text-gray-800 dark:text-white">{{ truncarTexto(venta.clienteNombre, 20) }}</span>
              </div>
              <div>
                <span class="text-[9px] text-gray-500 dark:text-gray-400 block uppercase font-bold">Vendedor</span>
                <span class="font-bold truncate block text-gray-800 dark:text-white">{{ truncarTexto(venta.vendedorNombre, 20) }}</span>
              </div>
            </div>
            
            <div class="text-[10px] text-gray-500 dark:text-gray-400 mb-2 line-clamp-2 font-bold">
              <Icon icon="mdi:package-variant" class="inline mr-1" />
              {{ venta.productos || 'Sin detalles' }}
            </div>
            
            <div class="flex justify-between items-center">
              <div class="flex items-center">
                <div class="w-6 h-6 bg-amber-100 dark:bg-amber-900/30 rounded-full flex items-center justify-center mr-2">
                  <Icon :icon="getMetodoPagoIcon(venta.metodoPago)" class="text-amber-600 dark:text-amber-400 text-xs" />
                </div>
                <span class="text-[10px] font-bold">
                  <span v-if="venta.cargandoPago" class="text-gray-400">Cargando...</span>
                  <span v-else>{{ formatearMetodoPagoVenta(venta) || 'N/A' }}</span>
                </span>
              </div>
              <div class="text-right">
                <div class="font-black text-base text-gray-800 dark:text-white">
                  ${{ formatNumber(venta.totalUsd) }}
                </div>
                <div v-if="esVentaCredito(venta)" class="text-[9px] font-black text-green-600 dark:text-green-400 uppercase">
                  Cobrado: ${{ formatNumber(sumarPagos(venta)) }}
                </div>
              </div>
            </div>

            <!-- Bloque Destino compacto en mobile -->
            <div v-if="venta._bancosInfo && venta._bancosInfo.length > 0" class="mt-2 space-y-1">
              <div v-for="(bc, idx) in venta._bancosInfo" :key="idx" class="p-2 bg-blue-50 dark:bg-blue-900/20 rounded-lg border border-blue-100 dark:border-blue-800">
                <span class="text-[9px] font-black text-blue-500 uppercase">Cuenta / Referencia</span>
                <p class="font-mono text-[11px] text-blue-700 dark:text-blue-300">
                  {{ 
                    formatearNumeroCuenta(bc.numeroCuenta) !== '—' 
                      ? formatearNumeroCuenta(bc.numeroCuenta) 
                      : (bc.referencia || bc.pmCodigoOperacion || '—') 
                  }}
                </p>
                <p class="text-[10px] text-gray-700 dark:text-gray-300 font-bold">
                  {{ bc.pmBancoEmisorCodigo ? nombreBanco(bc.pmBancoEmisorCodigo) : (bc.bancoNombre || '—') }}
                </p>
              </div>
            </div>
            
            <div class="flex justify-end gap-1 mt-3 pt-2 border-t border-gray-100 dark:border-gray-700">
              <button @click.stop="verDetalles(venta)" class="p-1.5 text-blue-600 hover:bg-blue-50 dark:hover:bg-blue-900/20 rounded-lg transition-colors" title="Ver Detalles">
                <Icon icon="mdi:eye-outline" class="text-base" />
              </button>
              <button @click.stop="imprimirVenta(venta)" class="p-1.5 text-indigo-600 hover:bg-indigo-50 dark:hover:bg-indigo-900/20 rounded-lg transition-colors" title="Imprimir Ticket">
                <Icon icon="mdi:printer" class="text-base" />
              </button>
              <button v-if="venta.estado === 'Pendiente'" @click.stop="abrirModalPago(venta)" class="p-1.5 text-green-600 hover:bg-green-50 dark:hover:bg-green-900/20 rounded-lg transition-colors" title="Registrar Pago">
                <Icon icon="mdi:check-circle-outline" class="text-base" />
              </button>
              <button @click.stop="abrirModalEliminar(venta)" class="p-1.5 text-red-600 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg transition-colors" title="Anular Venta">
                <Icon icon="mdi:delete-outline" class="text-base" />
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Vista desktop (tabla) -->
      <div class="hidden sm:block overflow-x-auto custom-scrollbar">
        <table class="w-full text-left border-collapse">
          <thead>
            <tr class="bg-gray-50 dark:bg-gray-900/50 border-b border-gray-200 dark:border-gray-700">
              <th class="px-5 py-4 text-[11px] font-black text-gray-400 tracking-widest">Factura</th>
              <th class="px-5 py-4 text-[11px] font-black text-gray-400 tracking-widest">Tipo</th>
              <th class="px-5 py-4 text-[11px] font-black text-gray-400 tracking-widest">Cliente</th>
              <th class="px-5 py-4 text-[11px] font-black text-gray-400 tracking-widest">Vendedor</th>
              <th class="px-5 py-4 text-[11px] font-black text-gray-400 tracking-widest">Método</th>
              <th class="px-5 py-4 text-[11px] font-black text-gray-400 tracking-widest">Total / Cobrado</th>
              <th class="px-5 py-4 text-[11px] font-black text-gray-400 tracking-widest">Destino</th>
              <th class="px-5 py-4 text-[11px] font-black text-gray-400 tracking-widest">Productos</th>
              <th class="px-5 py-4 text-[11px] font-black text-gray-400 tracking-widest text-center">Acciones</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-100 dark:divide-gray-700">
            <tr v-if="cargando" v-for="i in 5" :key="'load-'+i" class="animate-pulse">
              <td colspan="9" class="px-5 py-4"><div class="h-4 bg-gray-100 dark:bg-gray-700 rounded w-full"></div></td>
            </tr>
            <tr v-if="!cargando && ventasFiltradas.length === 0">
              <td colspan="9" class="px-5 py-16 text-center">
                <div class="flex flex-col items-center opacity-30 select-none">
                  <Icon icon="mdi:file-search-outline" class="text-7xl mb-3" />
                  <h4 class="text-xl font-black text-gray-400 tracking-widest">No hay ventas</h4>
                </div>
              </td>
            </tr>
            <tr v-for="venta in ventasPaginadas" :key="venta.idVenta"
                @click="verDetalles(venta)"
                class="hover:bg-indigo-50/30 dark:hover:bg-gray-700/30 transition-all group cursor-pointer">
              <td class="px-5 py-4">
                <div class="font-bold text-gray-900 dark:text-white text-sm">{{ venta.numeroFactura }}</div>
                <div class="text-[10px] text-gray-500 font-bold">{{ formatFecha(venta.fechaVenta) }}</div>
              </td>
              <td class="px-5 py-4">
                <span v-if="venta.tipoVenta" 
                      class="px-2.5 py-1 text-[9px] rounded-full font-black uppercase"
                      :class="getTipoVentaClasses(venta.tipoVenta)">
                  {{ formatearTipoVentaConCredito(venta.tipoVenta, venta.idTipoCredito) }}
                </span>
                <span v-else class="text-gray-400 text-xs font-bold">-</span>
              </td>
              <td class="px-5 py-4">
                <div class="flex items-center gap-2">
                  <div class="w-7 h-7 bg-gray-100 dark:bg-gray-700 rounded-lg flex items-center justify-center font-black text-gray-500 text-xs">
                    {{ (venta.clienteNombre || '?').charAt(0) }}
                  </div>
                  <span class="font-bold text-gray-900 dark:text-white text-xs truncate max-w-[150px]">{{ truncarTexto(venta.clienteNombre, 25) }}</span>
                </div>
              </td>
              <td class="px-5 py-4">
                <div class="flex items-center gap-1.5">
                  <Icon icon="mdi:account-tie" class="text-gray-400 text-sm" />
                  <span class="font-bold text-gray-600 dark:text-gray-300 text-xs">{{ truncarTexto(venta.vendedorNombre, 20) }}</span>
                </div>
              </td>
              <td class="px-5 py-4">
                <div class="flex items-center gap-1.5">
                  <Icon :icon="getMetodoPagoIcon(venta.metodoPago)" class="text-amber-600 text-sm" />
                  <span v-if="venta.cargandoPago" class="text-gray-400 text-xs font-bold">Cargando...</span>
                  <span v-else class="font-bold text-gray-800 dark:text-white text-xs">{{ formatearMetodoPagoVenta(venta) || '—' }}</span>
                </div>
              </td>
              <td class="px-5 py-4">
                <div class="font-black text-gray-900 dark:text-white text-sm">${{ formatNumber(venta.totalUsd) }}</div>
                <div v-if="esVentaCredito(venta)" class="text-[9px] font-black text-green-600 dark:text-green-400 uppercase tracking-tighter">
                  Cobrado: ${{ formatNumber(sumarPagos(venta)) }}
                </div>
              </td>
              <!-- Destino: Cuenta o Referencia PM + Banco Emisor -->
              <td class="px-5 py-4">
                <div v-if="venta._bancosInfo && venta._bancosInfo.length > 0" class="flex flex-col gap-1">
                  <div v-for="(bc, idx) in venta._bancosInfo" :key="idx" class="leading-tight">
                    <span class="font-mono text-[10px] text-blue-600 dark:text-blue-400 block">
                      {{ 
                        formatearNumeroCuenta(bc.numeroCuenta) !== '—' 
                          ? formatearNumeroCuenta(bc.numeroCuenta) 
                          : (bc.referencia || bc.pmCodigoOperacion || '—') 
                      }}
                    </span>
                    <span class="text-[9px] text-gray-500 dark:text-gray-400 font-bold block">
                      {{ bc.pmBancoEmisorCodigo ? nombreBanco(bc.pmBancoEmisorCodigo) : (bc.bancoNombre || '—') }}
                    </span>
                  </div>
                </div>
                <span v-else class="text-gray-400 text-xs font-bold">—</span>
              </td>
              <td class="px-5 py-4">
                <span class="text-[10px] font-bold text-gray-500 dark:text-gray-400 max-w-[150px] truncate block" :title="venta.productos">{{ venta.productos || '—' }}</span>
              </td>
              <td class="px-5 py-4">
                <div class="flex items-center justify-center gap-0.5 flex-nowrap whitespace-nowrap">
                  <button @click.stop="verDetalles(venta)" class="p-1.5 bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 rounded-lg hover:bg-blue-600 hover:text-white transition-all shadow-sm flex-shrink-0" title="Ver Detalles">
                    <Icon icon="mdi:eye-outline" class="text-base" />
                  </button>
                  <button @click.stop="imprimirVenta(venta)" class="p-1.5 bg-indigo-50 dark:bg-indigo-900/30 text-indigo-600 dark:text-indigo-400 rounded-lg hover:bg-indigo-600 hover:text-white transition-all shadow-sm flex-shrink-0" title="Imprimir Ticket">
                    <Icon icon="mdi:printer" class="text-base" />
                  </button>
                  <button v-if="venta.estado === 'Pendiente'" @click.stop="abrirModalPago(venta)" class="p-1.5 bg-green-50 dark:bg-green-900/30 text-green-600 dark:text-green-400 rounded-lg hover:bg-green-600 hover:text-white transition-all shadow-sm flex-shrink-0" title="Registrar Pago">
                    <Icon icon="mdi:check-circle-outline" class="text-base" />
                  </button>
                  <button @click.stop="abrirModalEliminar(venta)" class="p-1.5 bg-red-50 dark:bg-red-900/30 text-red-600 dark:text-red-400 rounded-lg hover:bg-red-600 hover:text-white transition-all shadow-sm flex-shrink-0" title="Anular Venta">
                    <Icon icon="mdi:delete-outline" class="text-base" />
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Paginación Premium -->
      <div v-if="ventasFiltradas.length > itemsPorPagina" class="bg-gray-50/50 dark:bg-gray-800/50 px-3 sm:px-5 py-3 border-t border-gray-200 dark:border-gray-700 flex flex-col sm:flex-row items-center justify-between gap-3">
        <div class="text-[9px] sm:text-[11px] font-black text-gray-400 uppercase tracking-widest text-center sm:text-left">
          Mostrando {{ startIndex + 1 }} - {{ Math.min(endIndex, ventasFiltradas.length) }} <span class="mx-1 text-gray-300">|</span> Total: {{ ventasFiltradas.length }}
        </div>
        <div class="flex items-center gap-1 flex-wrap justify-center">
          <button @click="paginaAnterior" :disabled="paginaActual === 1" :class="['p-1.5 rounded-lg border transition-all', paginaActual === 1 ? 'opacity-30 cursor-not-allowed border-gray-200 dark:border-gray-700' : 'hover:bg-white dark:hover:bg-gray-700 border-gray-200 dark:border-gray-600 shadow-sm']">
            <Icon icon="mdi:chevron-left" class="text-base sm:text-xl" />
          </button>
          
          <div class="hidden sm:flex items-center gap-0.5 sm:gap-1 mx-1 sm:mx-2">
            <button v-for="page in paginasVisiblesMobile" :key="page" @click="irAPagina(page)" :class="['w-7 h-7 sm:w-9 sm:h-9 rounded-lg text-[10px] sm:text-xs font-black transition-all flex items-center justify-center', paginaActual === page ? 'bg-blue-600 text-white shadow-md shadow-blue-500/30' : 'text-gray-500 hover:bg-white dark:hover:bg-gray-700 border border-transparent hover:border-gray-200 dark:hover:border-gray-600']">
              {{ page }}
            </button>
          </div>
          <span class="sm:hidden text-xs font-black text-gray-600 dark:text-gray-300 px-2">{{ paginaActual }} / {{ totalPaginas }}</span>

          <button @click="paginaSiguiente" :disabled="paginaActual === totalPaginas" :class="['p-1.5 rounded-lg border transition-all', paginaActual === totalPaginas ? 'opacity-30 cursor-not-allowed border-gray-200 dark:border-gray-700' : 'hover:bg-white dark:hover:bg-gray-700 border-gray-200 dark:border-gray-600 shadow-sm']">
            <Icon icon="mdi:chevron-right" class="text-base sm:text-xl" />
          </button>
        </div>
      </div>
    </div>

    <!-- ============================================ -->
    <!-- MODAL DE PAGO -->
    <!-- ============================================ -->
    <Teleport to="body">
      <div v-if="modalPago.show" class="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-3 sm:p-4 z-[9999]" @click.self="cerrarModalPago">
        <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-sm overflow-hidden animate-zoomIn">
          <div class="bg-gradient-to-r from-green-600 to-emerald-600 px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between">
            <div class="flex items-center gap-2 sm:gap-3">
              <div class="p-1.5 sm:p-2 bg-white/20 rounded-xl">
                <Icon icon="mdi:check-circle" class="text-white text-lg sm:text-xl" />
              </div>
              <div>
                <h3 class="text-sm sm:text-base font-bold text-white uppercase tracking-wider">Confirmar Pago</h3>
                <p class="text-[8px] sm:text-[10px] text-green-100 font-bold">Procesar liquidación de factura</p>
              </div>
            </div>
            <button @click="cerrarModalPago" class="p-1.5 bg-white/10 hover:bg-white/20 rounded-lg transition-all">
              <Icon icon="mdi:close" class="text-white text-lg sm:text-xl" />
            </button>
          </div>

          <div class="p-4 sm:p-6">
            <div class="bg-gray-50 dark:bg-gray-700/30 p-3 sm:p-4 rounded-xl border border-gray-100 dark:border-gray-700 text-left mb-4 sm:mb-6">
              <div class="flex justify-between text-[9px] sm:text-[10px] font-bold text-gray-400 uppercase mb-1">
                <span>Factura</span>
                <span class="text-gray-800 dark:text-white font-black text-xs sm:text-sm">{{ ventaParaPago?.numeroFactura }}</span>
              </div>
              <div class="flex justify-between text-[9px] sm:text-[10px] font-bold text-gray-400 uppercase">
                <span>Total a Pagar</span>
                <span class="text-green-600 text-sm sm:text-base font-black">${{ formatNumber(ventaParaPago?.totalUsd) }}</span>
              </div>
            </div>

            <div class="flex flex-col sm:flex-row gap-2">
              <button @click="cerrarModalPago" class="w-full sm:flex-1 px-4 py-2 text-[10px] sm:text-xs font-black text-gray-400 uppercase border border-gray-100 dark:border-gray-700 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-all">Cancelar</button>
              <button @click="confirmarPago" :disabled="procesandoPago" class="w-full sm:flex-1 px-4 py-2 bg-green-600 text-white rounded-lg text-[10px] sm:text-xs font-black uppercase shadow-md hover:bg-green-700 disabled:opacity-50 transition-all flex items-center justify-center gap-2">
                <Icon v-if="procesandoPago" icon="mdi:loading" class="animate-spin" />
                {{ procesandoPago ? 'Procesando...' : 'Confirmar' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Teleport>

    <!-- ============================================ -->
    <!-- MODAL DE ELIMINAR -->
    <!-- ============================================ -->
    <Teleport to="body">
      <div v-if="modalEliminar.show" class="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-3 sm:p-4 z-[10000]" @click.self="cerrarModalEliminar">
        <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-sm overflow-hidden animate-zoomIn">
          <div class="bg-gradient-to-r from-red-600 to-rose-600 px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between">
            <div class="flex items-center gap-2 sm:gap-3">
              <div class="p-1.5 sm:p-2 bg-white/20 rounded-xl">
                <Icon icon="mdi:alert-circle" class="text-white text-lg sm:text-xl" />
              </div>
              <div>
                <h3 class="text-sm sm:text-base font-bold text-white uppercase tracking-wider">Anular Venta</h3>
                <p class="text-[8px] sm:text-[10px] text-red-100 font-bold">Esta acción es irreversible</p>
              </div>
            </div>
            <button @click="cerrarModalEliminar" class="p-1.5 bg-white/10 hover:bg-white/20 rounded-lg transition-all">
              <Icon icon="mdi:close" class="text-white text-lg sm:text-xl" />
            </button>
          </div>

          <div class="p-4 sm:p-6">
            <div class="bg-red-50/30 dark:bg-red-900/10 p-3 sm:p-4 rounded-xl border border-red-100 dark:border-red-900/30 text-center mb-4 sm:mb-6">
              <p class="text-[9px] sm:text-[10px] font-bold text-red-700 dark:text-red-400 uppercase mb-1 sm:mb-2">¿Estás seguro de anular la factura?</p>
              <p class="text-sm sm:text-base font-black text-gray-800 dark:text-white">{{ ventaParaEliminar?.numeroFactura }}</p>
            </div>

            <div class="flex flex-col sm:flex-row gap-2">
              <button @click="cerrarModalEliminar" class="w-full sm:flex-1 px-4 py-2 text-[10px] sm:text-xs font-black text-gray-400 uppercase border border-gray-100 dark:border-gray-700 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-all">Cancelar</button>
              <button @click="confirmarEliminar" :disabled="procesandoEliminar" class="w-full sm:flex-1 px-4 py-2 bg-red-600 text-white rounded-lg text-[10px] sm:text-xs font-black uppercase shadow-md hover:bg-red-700 disabled:opacity-50 transition-all flex items-center justify-center gap-2">
                <Icon v-if="procesandoEliminar" icon="mdi:loading" class="animate-spin" />
                {{ procesandoEliminar ? 'Anulando...' : 'Confirmar Anulación' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Teleport>

    <!-- ============================================ -->
    <!-- MODAL DE DETALLES -->
    <!-- ============================================ -->
    <Teleport to="body">
      <div v-if="modalDetalles.show" class="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-2 sm:p-4 z-[9997]" @click.self="cerrarModalDetalles">
        <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-4xl flex flex-col overflow-hidden animate-zoomIn max-h-[95vh]">
          <!-- Header -->
          <div class="bg-gradient-to-r from-blue-600 to-indigo-600 px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between flex-shrink-0">
            <div class="flex items-center gap-2 sm:gap-3">
              <div class="p-1.5 sm:p-2 bg-white/20 rounded-xl">
                <Icon icon="mdi:receipt-text" class="text-white text-lg sm:text-xl" />
              </div>
              <div>
                <h3 class="text-sm sm:text-base font-bold text-white uppercase tracking-wider">{{ ventaSeleccionada?.numeroFactura }}</h3>
                <p class="text-[8px] sm:text-[10px] text-blue-100 font-bold">{{ formatFechaCompleta(ventaSeleccionada?.fechaVenta) }}</p>
              </div>
            </div>
            <button @click="cerrarModalDetalles" class="p-1.5 bg-white/10 hover:bg-white/20 rounded-lg transition-all">
              <Icon icon="mdi:close" class="text-white text-lg sm:text-xl" />
            </button>
          </div>

          <!-- Tabs -->
          <div class="flex bg-gray-50 dark:bg-gray-800/50 border-b border-gray-200 dark:border-gray-700 p-1 flex-shrink-0">
            <button v-for="tab in (ventaSeleccionada?.cuotasCredito?.length > 0 ? ['resumen', 'productos', 'cuotas', 'pagos', 'observaciones'] : ['resumen', 'productos', 'pagos', 'observaciones'])" :key="tab" @click="tabActiva = tab" :class="['flex-1 py-1.5 sm:py-2 text-[8px] sm:text-[10px] font-black uppercase rounded-lg transition-all', tabActiva === tab ? 'bg-white dark:bg-gray-700 text-blue-600 shadow-sm' : 'text-gray-400 hover:text-gray-600']">{{ tab }}</button>
          </div>

          <!-- Content -->
          <div class="flex-1 overflow-y-auto p-3 sm:p-6 custom-scrollbar">
            <!-- RESUMEN (sin bloque bancario) -->
            <div v-if="tabActiva === 'resumen'" class="space-y-3 sm:space-y-4 animate-fadeIn">
              <div class="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-4">
                <div class="p-3 sm:p-4 bg-gray-50 dark:bg-gray-800/50 rounded-2xl border border-gray-100 dark:border-gray-700">
                  <span class="text-[9px] sm:text-[10px] font-bold text-gray-400 uppercase block mb-0.5 sm:mb-1">Cliente</span>
                  <span class="text-sm sm:text-base font-black text-gray-800 dark:text-white">{{ ventaSeleccionada?.clienteNombre || 'N/A' }}</span>
                </div>
                <div class="p-3 sm:p-4 bg-gray-50 dark:bg-gray-800/50 rounded-2xl border border-gray-100 dark:border-gray-700">
                  <span class="text-[9px] sm:text-[10px] font-bold text-gray-400 uppercase block mb-0.5 sm:mb-1">Vendedor</span>
                  <span class="text-sm sm:text-base font-black text-gray-800 dark:text-white">{{ ventaSeleccionada?.vendedorNombre || 'N/A' }}</span>
                </div>
              </div>
              <div class="grid grid-cols-2 sm:grid-cols-4 gap-2">
                <div class="p-2 sm:p-3 bg-blue-500/5 rounded-xl text-center">
                  <p class="text-[8px] sm:text-[9px] font-bold text-blue-400 uppercase mb-0.5">Total USD</p>
                  <p class="text-xs sm:text-sm font-black text-blue-600">${{ formatNumber(ventaSeleccionada?.totalUsd) }}</p>
                </div>
                <div class="p-2 sm:p-3 bg-green-500/5 rounded-xl text-center">
                  <p class="text-[8px] sm:text-[9px] font-bold text-green-400 uppercase mb-0.5">Estado</p>
                  <p class="text-[8px] sm:text-[10px] font-black text-green-600 uppercase">{{ ventaSeleccionada?.estado || 'Pendiente' }}</p>
                </div>
                <div class="p-2 sm:p-3 bg-amber-500/5 rounded-xl text-center col-span-2">
                  <p class="text-[8px] sm:text-[9px] font-bold text-amber-400 uppercase mb-0.5">Método</p>
                  <p class="text-[8px] sm:text-[10px] font-black text-amber-600 uppercase">{{ formatearMetodoPagoVenta(ventaSeleccionada) || 'Efectivo' }}</p>
                </div>
              </div>
            </div>

            <!-- PRODUCTOS -->
            <div v-if="tabActiva === 'productos'" class="space-y-2 animate-fadeIn">
              <div v-for="detalle in ventaSeleccionada?.detalles" :key="detalle.idVentaDetalle" class="flex items-center justify-between p-2 sm:p-3 bg-gray-50 dark:bg-gray-800/50 rounded-xl border border-gray-100 dark:border-gray-700">
                <div>
                  <p class="text-xs sm:text-sm font-bold text-gray-800 dark:text-white uppercase">{{ detalle.nombreProducto || detalle.productoNombre || 'Producto' }}</p>
                  <p class="text-[8px] sm:text-[10px] text-gray-400 font-bold uppercase">{{ detalle.cantidad }} Uds x ${{ formatNumber(detalle.precioUnitarioUsd) }}</p>
                </div>
                <p class="text-xs sm:text-sm font-black text-blue-600">${{ formatNumber(detalle.subtotalUsd) }}</p>
              </div>
              <div v-if="!ventaSeleccionada?.detalles?.length" class="text-center py-8">
                <Icon icon="mdi:package-off" class="text-4xl text-gray-300 mx-auto mb-2" />
                <p class="text-[10px] font-bold text-gray-400 uppercase">Sin productos registrados</p>
              </div>
            </div>

            <!-- CUOTAS -->
            <div v-if="tabActiva === 'cuotas'" class="space-y-2 animate-fadeIn">
              <div v-if="ventaSeleccionada?.cuotasCredito?.length > 0" class="space-y-2">
                <div v-for="cuota in ventaSeleccionada.cuotasCredito" :key="cuota.idCreditoCuota || cuota.numeroCuota" class="p-3 bg-gray-50 dark:bg-gray-800/50 rounded-xl border border-gray-100 dark:border-gray-700 flex items-center justify-between">
                  <div>
                    <div class="flex items-center gap-2">
                      <span class="text-xs font-black uppercase text-indigo-600 dark:text-indigo-400">Cuota #{{ cuota.numeroCuota }}</span>
                      <span :class="cuota.estado === 'PAGADO' || cuota.estado === 'PAGADA' ? 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400' : (cuota.estado === 'VENCIDO' ? 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400' : 'bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400')"
                            class="px-2 py-0.5 text-[8px] sm:text-[9px] font-black uppercase rounded-full">
                        {{ cuota.estado || 'PENDIENTE' }}
                      </span>
                    </div>
                    <p class="text-[8px] sm:text-[10px] text-gray-400 font-bold mt-0.5">
                      Vencimiento: {{ formatFecha(cuota.fechaVencimiento) }}
                    </p>
                  </div>
                  <div class="text-right">
                    <p class="text-xs sm:text-sm font-black text-indigo-600 dark:text-indigo-400">${{ formatNumber(cuota.montoUsd) }}</p>
                    <p v-if="cuota.saldoUsd > 0 && cuota.saldoUsd !== cuota.montoUsd" class="text-[8px] sm:text-[9px] text-rose-500 font-bold">
                      Pendiente: ${{ formatNumber(cuota.saldoUsd) }}
                    </p>
                  </div>
                </div>
              </div>
              <div v-else class="text-center py-8">
                <Icon icon="mdi:calendar-blank" class="text-4xl text-gray-300 mx-auto mb-2" />
                <p class="text-[10px] font-bold text-gray-400 uppercase">Sin cuotas calendarizadas</p>
              </div>
            </div>

            <!-- PAGOS (con bloque bancario completo por recibo) -->
            <div v-if="tabActiva === 'pagos'" class="space-y-3 sm:space-y-4 animate-fadeIn">
              <div v-if="ventaSeleccionada?.pagos?.length > 0">
                <div v-for="(pago, i) in ventaSeleccionada.pagos" :key="i" class="p-3 sm:p-4 rounded-2xl bg-white dark:bg-gray-800 border border-gray-100 dark:border-gray-700 shadow-sm">
                  <!-- Header del recibo -->
                  <div class="flex justify-between items-center border-b border-gray-50 dark:border-gray-700 pb-2 mb-2">
                    <span class="text-[9px] sm:text-[10px] font-black text-indigo-500 uppercase">Recibo #{{ i+1 }}</span>
                    <span class="text-[9px] sm:text-[10px] font-bold text-gray-400">{{ formatFechaCompleta(pago.fechaPago) }}</span>
                  </div>

                  <!-- Monto y vía -->
                  <div class="flex justify-between items-end mb-2">
                    <div>
                      <p class="text-[9px] sm:text-[10px] font-bold text-gray-400 uppercase">Vía: {{ pago.tipoPago || 'Efectivo' }}</p>
                      <p v-if="pago.referencia" class="text-[9px] text-gray-400">Ref: {{ pago.referencia }}</p>
                    </div>
                    <p class="text-base sm:text-lg font-black text-green-600">${{ formatNumber(pago.montoUsd) }}</p>
                  </div>

                  <!-- Bloque completo "Cuenta donde cayó el pago" por recibo -->
                  <template v-if="(pago._bancosInfo && pago._bancosInfo.length > 0) || (ventaSeleccionada._bancosInfo && ventaSeleccionada._bancosInfo.length > 0)">
                    <div
                      v-for="(bc, idx) in (pago._bancosInfo && pago._bancosInfo.length > 0 ? pago._bancosInfo : ventaSeleccionada._bancosInfo)"
                      :key="idx"
                      class="mt-2 p-3 bg-blue-50 dark:bg-blue-900/20 rounded-xl border border-blue-100 dark:border-blue-800"
                    >
                      <span class="text-[9px] sm:text-[10px] font-bold text-blue-500 uppercase block mb-1">Cuenta donde cayó el pago</span>
                      <p class="text-sm sm:text-base font-black text-gray-800 dark:text-white">
                        {{ bc.bancoNombre || nombreBanco(bc.bancoCodigo) }} ({{ bc.bancoCodigo || '—' }})
                      </p>
                      <p class="font-mono text-[11px] sm:text-xs text-blue-700 dark:text-blue-300">
                        {{ formatearNumeroCuenta(bc.numeroCuenta) !== '—' ? formatearNumeroCuenta(bc.numeroCuenta) : (bc.referencia || bc.pmCodigoOperacion || '—') }}
                      </p>
                      <p class="text-[10px] sm:text-xs text-gray-600 dark:text-gray-400">
                        {{ bc.titularNombreCompleto || '—' }} · {{ bc.titularDocumento || '—' }} · {{ bc.titularTelefono || '—' }}
                      </p>
                      <div class="mt-2 grid grid-cols-1 sm:grid-cols-2 gap-1 text-[9px] sm:text-[10px] border-t border-blue-200 dark:border-blue-800 pt-2">
                        <div>
                          <span class="font-black text-indigo-500">Bco. Emisor:</span>
                          {{ bc.pmBancoEmisorCodigo || '—' }} — {{ nombreBanco(bc.pmBancoEmisorCodigo) }}
                        </div>
                        <div>
                          <span class="font-black text-indigo-500">Bco. Receptor:</span>
                          {{ bc.pmBancoReceptorCodigo || '—' }} — {{ nombreBanco(bc.pmBancoReceptorCodigo) }}
                        </div>
                        <div>
                          <span class="font-black text-indigo-500">Tel. Emisor:</span>
                          {{ bc.pmTelefonoEmisor || '—' }}
                        </div>
                        <div>
                          <span class="font-black text-indigo-500">Doc. Emisor:</span>
                          {{ bc.pmDocumentoEmisor || '—' }}
                        </div>
                        <div class="sm:col-span-2">
                          <span class="font-black text-indigo-500">Cód. Operación:</span>
                          {{ bc.pmCodigoOperacion || '—' }}
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
              <div v-else class="text-center py-8 sm:py-10">
                <Icon icon="mdi:cash-off" class="text-4xl sm:text-5xl text-gray-200 mx-auto mb-2" />
                <p class="text-[9px] sm:text-[10px] font-bold text-gray-400 uppercase">No se registran pagos</p>
              </div>
            </div>

            <!-- OBSERVACIONES -->
            <div v-if="tabActiva === 'observaciones'" class="p-3 sm:p-4 bg-gray-50 dark:bg-gray-800/50 rounded-2xl min-h-[80px] sm:min-h-[100px] border border-gray-100 dark:border-gray-700 animate-fadeIn">
              <p class="text-xs sm:text-sm text-gray-600 dark:text-gray-300">{{ ventaSeleccionada?.observaciones || 'Sin comentarios adicionales.' }}</p>
            </div>
          </div>

          <!-- Footer -->
          <div class="px-4 sm:px-6 py-3 sm:py-4 border-t border-gray-100 dark:border-gray-700 bg-gray-50/50 dark:bg-gray-800/50 flex flex-col sm:flex-row justify-end gap-2 flex-shrink-0">
            <button @click="cerrarModalDetalles" class="w-full sm:w-auto px-4 sm:px-6 py-2 text-[10px] sm:text-xs font-black text-gray-400 uppercase hover:text-gray-600 transition-colors">Cerrar Detalle</button>
            <button v-if="ventaSeleccionada?.estado === 'Pendiente'" @click="abrirModalPago(ventaSeleccionada); cerrarModalDetalles()" class="w-full sm:w-auto px-6 sm:px-8 py-2 bg-green-600 text-white rounded-xl text-[10px] sm:text-xs font-black uppercase shadow-md hover:bg-green-700 transition-all">Registrar Pago</button>
          </div>
        </div>
      </div>
    </Teleport>
  </div>
</template>

<script>
import { Icon } from "@iconify/vue";
import { obtenerVentas, actualizarVenta, eliminarVenta as eliminarVentaApi, obtenerVentaConRelaciones } from '@/api/ventas.js';
import { obtenerPagosPorVenta } from '@/api/pagoVenta.js';
import { obtenerMetodosPagoActivos } from '@/api/metodosPago.api.js';
import { obtenerVendedores } from '@/api/vendedores.js';
import { obtenerClientes } from '@/api/clientes.js';
import { obtenerTasaActiva } from '@/api/tasas.js';
import { imprimirFactura } from '@/utils/facturaGenerator.js';
import { useToast } from "vue-toastification";
import { notificarVenta } from '@/utils/notificacionesHelper';
import { obtenerPagosCuenta, formatearNumeroCuenta } from '@/api/bancos.js';

// Mapa de códigos de banco → nombre
const BANCOS_CODIGOS = {
  '0102': 'Banco de Venezuela', '0104': 'Venezolano de Crédito', '0105': 'Mercantil',
  '0108': 'Provincial', '0114': 'Bancaribe', '0115': 'Exterior', '0128': 'Banco Caroní',
  '0134': 'Banesco', '0137': 'Sofitasa', '0138': 'Banco Plaza', '0146': 'Bangente',
  '0151': 'BFC Banco Fondo Común', '0156': '100% Banco', '0157': 'DelSur',
  '0163': 'Banco del Tesoro', '0166': 'Banco Agrícola de Venezuela', '0168': 'Bancrecer',
  '0169': 'Mi Banco', '0171': 'Banco Activo', '0172': 'Bancamiga', '0174': 'Banplus',
  '0175': 'Bicentenario', '0177': 'Banfanb', '0191': 'BNC Banco Nacional de Crédito'
};

// CACHE GLOBAL DE PAGOS DE CUENTA
const CACHE_BANCOS = {
  pagosCuenta: null,
  pagosCuentaTimestamp: 0,
  porTipoDocIdDoc: null,
  porIdVenta: null,
  porIdPagoVenta: null,
  porReferencia: null,
  porReferenciaMonto: null
};
const TTL_PAGOS_CUENTA = 2 * 60 * 1000;

function withTimeout(promise, ms = 8000) {
  return Promise.race([
    promise,
    new Promise((_, reject) => setTimeout(() => reject(new Error('Timeout')), ms))
  ]);
}

function normStr(s) {
  if (s === null || s === undefined) return '';
  return String(s).trim().toUpperCase()
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

export default {
  name: 'VentasList',
  components: { Icon },
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      ventas: [],
      ventasFiltradas: [],
      cargando: false,
      cargandoPagos: false,
      
      filtro: {
        numeroFactura: '',
        idCliente: '',
        idVendedor: '',
        metodoPago: '',
        estado: '',
        fechaDesde: new Date().toLocaleDateString('sv-SE'),
        fechaHasta: ''
      },
      mostrarFiltros: true,
      
      paginaActual: 1,
      itemsPorPagina: 5,
      maxVisiblePages: 10,
      
      modalDetalles: { show: false },
      modalPago: { show: false },
      modalEliminar: { show: false },
      
      ventaSeleccionada: null,
      ventaParaPago: null,
      ventaParaEliminar: null,
      tabActiva: 'resumen',
      
      procesandoPago: false,
      procesandoEliminar: false,
      
      clientesMap: new Map(),
      clientesFullMap: new Map(),
      vendedoresMap: new Map(),
      clientesUnicos: [],
      vendedoresUnicos: [],
      metodosPago: []
    };
  },
  computed: {
    totalPaginas() { return Math.ceil(this.ventasFiltradas.length / this.itemsPorPagina); },
    ventasPaginadas() { const start = (this.paginaActual - 1) * this.itemsPorPagina; return this.ventasFiltradas.slice(start, start + this.itemsPorPagina); },
    startIndex() { return (this.paginaActual - 1) * this.itemsPorPagina; },
    endIndex() { return Math.min(this.startIndex + this.itemsPorPagina, this.ventasFiltradas.length); },
    paginasVisiblesMobile() {
      const total = this.totalPaginas, current = this.paginaActual;
      if (total <= 5) return Array.from({length: total}, (_, i) => i + 1);
      if (current <= 3) return [1, 2, 3, 4, 5];
      if (current >= total - 2) return [total - 4, total - 3, total - 2, total - 1, total];
      return [current - 2, current - 1, current, current + 1, current + 2];
    },
    ventasPagadas() { return this.ventas.filter(v => v.estado !== 'Anulada' && v.estado !== 'Cancelada'); },
    ventasHoy() { const hoy = new Date().toDateString(); return this.ventas.filter(v => new Date(v.fechaVenta).toDateString() === hoy); },
    porcentajePagadas() { return this.ventas.length ? Math.round((this.ventasPagadas.length / this.ventas.length) * 100) : 0; },
    filtrosActivos() { return this.filtro.numeroFactura || this.filtro.idCliente || this.filtro.idVendedor || this.filtro.metodoPago || this.filtro.estado || this.filtro.fechaDesde || this.filtro.fechaHasta; }
  },
  watch: {
    '$route.query.idVenta'(newId, oldId) {
      if (newId && newId !== oldId) {
        this.abrirDetalleDesdeURL(newId);
      }
    }
  },
  async mounted() { 
    await Promise.all([
      this.cargarDatosMaestros(),
      this.cargarPagosCuentaDesdeCache(),
      this.cargarVentas()
    ]);
    
    const idVentaParam = this.$route.query.idVenta;
    if (idVentaParam) {
      this.abrirDetalleDesdeURL(idVentaParam);
    }
  },
  beforeUnmount() {
    if (this._timerDetalles) clearTimeout(this._timerDetalles);
  },
  methods: {
    formatearNumeroCuenta,

    nombreBanco(codigo) {
      if (!codigo) return '—';
      return BANCOS_CODIGOS[String(codigo).trim()] || String(codigo);
    },

    async cargarPagosCuentaDesdeCache(force = false) {
      const ahora = Date.now();
      const valido = !force && CACHE_BANCOS.pagosCuenta && (ahora - CACHE_BANCOS.pagosCuentaTimestamp) < TTL_PAGOS_CUENTA;
      if (valido) return CACHE_BANCOS.pagosCuenta;
      if (CACHE_BANCOS._promesa) return await CACHE_BANCOS._promesa;

      CACHE_BANCOS._promesa = (async () => {
        try {
          const res = await withTimeout(obtenerPagosCuenta(), 10000);
          if (res.success) {
            CACHE_BANCOS.pagosCuenta = res.data || [];
            
            CACHE_BANCOS.porTipoDocIdDoc = {};
            CACHE_BANCOS.porIdVenta = {};
            CACHE_BANCOS.porIdPagoVenta = {};
            CACHE_BANCOS.porReferencia = {};
            CACHE_BANCOS.porReferenciaMonto = {};

            CACHE_BANCOS.pagosCuenta.forEach(pc => {
              if (pc.tipoDocumentoPago && pc.idDocumentoPago != null) {
                const key = `${normStr(pc.tipoDocumentoPago)}-${pc.idDocumentoPago}`;
                CACHE_BANCOS.porTipoDocIdDoc[key] = pc;
              }
              const idV = pc.idVenta ?? pc.id_venta;
              if (idV != null) CACHE_BANCOS.porIdVenta[String(idV)] = pc;
              const idPV = pc.idPagoVenta ?? pc.id_pago_venta;
              if (idPV != null) CACHE_BANCOS.porIdPagoVenta[String(idPV)] = pc;
              const ref = normStr(pc.referencia);
              if (ref) CACHE_BANCOS.porReferencia[ref] = pc;
              if (ref) {
                const monto = Math.round((Number(pc.montoUsd) || 0) * 100);
                CACHE_BANCOS.porReferenciaMonto[`${ref}|${monto}`] = pc;
              }
            });

            CACHE_BANCOS.pagosCuentaTimestamp = Date.now();
            console.log('✅ PagosCuenta indexados:', CACHE_BANCOS.pagosCuenta.length);
          }
        } catch (e) {
          console.warn('⚠️ Error cargando pagos de cuenta bancaria:', e);
          if (!CACHE_BANCOS.pagosCuenta) {
            CACHE_BANCOS.pagosCuenta = [];
            CACHE_BANCOS.porTipoDocIdDoc = {};
            CACHE_BANCOS.porIdVenta = {};
            CACHE_BANCOS.porIdPagoVenta = {};
            CACHE_BANCOS.porReferencia = {};
            CACHE_BANCOS.porReferenciaMonto = {};
          }
        } finally {
          CACHE_BANCOS._promesa = null;
        }
      })();

      return await CACHE_BANCOS._promesa;
    },

    buscarTodosBancosInfo(venta) {
      if (!venta || !CACHE_BANCOS.pagosCuenta) return [];
      
      const matches = new Set();
      const add = (pc) => { if (pc) matches.add(pc); };
      
      if (CACHE_BANCOS.porIdVenta[String(venta.idVenta)]) {
        add(CACHE_BANCOS.porIdVenta[String(venta.idVenta)]);
      }
      
      const key1 = `${normStr('venta')}-${venta.idVenta}`;
      if (CACHE_BANCOS.porTipoDocIdDoc[key1]) add(CACHE_BANCOS.porTipoDocIdDoc[key1]);
      
      if (venta.numeroFactura) {
        const nf = String(venta.numeroFactura).trim();
        CACHE_BANCOS.pagosCuenta.forEach(pc => {
          const idDoc = String(pc.idDocumentoPago || '').trim();
          if (idDoc && idDoc === nf) add(pc);
        });
      }
      
      if (venta.pagos && venta.pagos.length > 0) {
        for (const p of venta.pagos) {
          if (p.idPago && CACHE_BANCOS.porIdPagoVenta[String(p.idPago)]) {
            add(CACHE_BANCOS.porIdPagoVenta[String(p.idPago)]);
          }
          const ref = normStr(p.referencia);
          if (ref) {
            if (CACHE_BANCOS.porReferencia[ref]) add(CACHE_BANCOS.porReferencia[ref]);
            const monto = Math.round((Number(p.montoUsd) || 0) * 100);
            if (CACHE_BANCOS.porReferenciaMonto[`${ref}|${monto}`]) {
              add(CACHE_BANCOS.porReferenciaMonto[`${ref}|${monto}`]);
            }
          }
        }
      }
      
      return [...matches].sort((a, b) => {
        const aPm = a.pmCodigoOperacion ? 1 : 0;
        const bPm = b.pmCodigoOperacion ? 1 : 0;
        return bPm - aPm;
      });
    },

    buscarBancoInfo(venta) {
      const arr = this.buscarTodosBancosInfo(venta);
      return arr.length > 0 ? arr[0] : null;
    },

    goToFirstPage() { this.paginaActual = 1; },
    goToLastPage() { this.paginaActual = this.totalPaginas; },
    
    async abrirDetalleDesdeURL(id) {
      try {
        const idVenta = parseInt(id);
        const venta = this.ventas.find(v => v.idVenta === idVenta);
        if (venta) {
          this.verDetalles(venta);
        } else {
          const res = await obtenerVentaConRelaciones(idVenta);
          if (res.success && res.data) {
            const ventaNormalizada = this.normalizarVenta(res.data);
            this.verDetalles(ventaNormalizada);
          }
        }
      } catch (e) {
        console.error('Error al abrir detalle desde URL:', e);
      }
    },
    
    normalizarVenta(venta) {
      const clienteNombre = this.clientesMap.get(venta.idCliente) || `Cliente ${venta.idCliente}`;
      const vendedorNombre = this.vendedoresMap.get(venta.idVendedor) || `Vendedor ${venta.idVendedor}`;
      
      return {
        idVenta: venta.idVenta,
        numeroFactura: venta.numeroFactura,
        fechaVenta: venta.fechaVenta,
        tipoVenta: venta.tipoVenta,
        subtotalUsd: venta.subtotalUsd || 0,
        ivaUsd: venta.ivaUsd || 0,
        descuentoUsd: venta.descuentoUsd || 0,
        totalUsd: venta.totalUsd || 0,
        subtotalBs: venta.subtotalBs || 0,
        ivaBs: venta.ivaBs || 0,
        descuentoBs: venta.descuentoBs || 0,
        totalBs: venta.totalBs || 0,
        costoTotalUsd: venta.costoTotalUsd || 0,
        gananciaNetaUsd: venta.gananciaNetaUsd || 0,
        margenGananciaPorcentaje: venta.margenGananciaPorcentaje || 0,
        estado: venta.estado,
        productos: venta.productos,
        observaciones: venta.observaciones,
        idCliente: venta.idCliente,
        clienteNombre: clienteNombre,
        idVendedor: venta.idVendedor,
        vendedorNombre: vendedorNombre,
        idTipoCredito: venta.idTipoCredito || null,
        metodoPago: 'efectivo',
        pagos: [],
        detalles: venta.detalles || [],
        cantidadTotal: venta.cantidadTotal || 0,
        cargandoPago: true,
        _bancosInfo: []
      };
    },

    normalizarPago(pago) {
      return {
        idPago: pago.idPago,
        idVenta: pago.idVenta,
        idCuota: pago.idCuota,
        fechaPago: pago.fechaPago,
        montoUsd: pago.montoUsd || 0,
        montoBs: pago.montoBs || 0,
        tipoPago: pago.tipoPago,
        numeroRecibo: pago.numeroRecibo,
        referencia: pago.referencia || pago.referenciaPago || null,
        observaciones: pago.observaciones,
        pmCodigoOperacion: pago.pmCodigoOperacion || pago.referencia, // ⭐ Asegurar captura
        _bancosInfo: []
      };
    },

    async cargarDatosMaestros(force = false) {
      const ahora = Date.now();
      if (!force && this._maestrosCache && (ahora - this._maestrosCache) < 5 * 60 * 1000) {
        return;
      }
      
      try {
        const [clientesRes, vendedoresRes, metodosRes] = await Promise.all([
          obtenerClientes(),
          obtenerVendedores(),
          obtenerMetodosPagoActivos()
        ]);

        if (clientesRes.success && clientesRes.data) {
          this.clientesMap.clear();
          this.clientesFullMap.clear();
          clientesRes.data.forEach(cliente => {
            const nombreCompleto = `${cliente.nombre} ${cliente.apellido || ''}`.trim();
            this.clientesMap.set(cliente.idCliente, nombreCompleto);
            this.clientesFullMap.set(cliente.idCliente, cliente);
          });
          this.clientesUnicos = clientesRes.data.map(c => ({
            idCliente: c.idCliente,
            nombreCompleto: `${c.nombre} ${c.apellido || ''}`.trim()
          }));
        }

        if (vendedoresRes.success && vendedoresRes.data) {
          this.vendedoresMap.clear();
          vendedoresRes.data.forEach(vendedor => {
            const nombreCompleto = `${vendedor.nombre} ${vendedor.apellido || ''}`.trim();
            this.vendedoresMap.set(vendedor.idVendedor, nombreCompleto);
          });
          this.vendedoresUnicos = vendedoresRes.data.map(v => ({
            idVendedor: v.idVendedor,
            nombreCompleto: `${v.nombre} ${v.apellido || ''}`.trim()
          }));
        }

        if (metodosRes.success) {
          this.metodosPago = metodosRes.data || [];
        }
        
        this._maestrosCache = ahora;
      } catch (e) {
        console.error('Error cargando datos maestros:', e);
      }
    },

    getTipoVentaClasses(tipo, modal = false) {
      const clases = {
        'contado': modal ? 'bg-emerald-500/30 text-emerald-100' : 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300',
        'credito': modal ? 'bg-amber-500/30 text-amber-100' : 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300'
      };
      const tipoLower = tipo?.toLowerCase();
      return clases[tipoLower] || (modal ? 'bg-gray-500/30 text-gray-100' : 'bg-gray-100 text-gray-800 dark:bg-gray-900/30 dark:text-gray-300');
    },
    
    getMetodoPagoIcon(metodo) {
      if (!metodo) return 'mdi:credit-card-off-outline';
      const m = String(metodo).toLowerCase();
      if (m.includes('efectivo')) return 'mdi:cash';
      if (m.includes('pago móvil') || m.includes('pago movil')) return 'mdi:cellphone';
      if (m.includes('tarjeta') || m.includes('punto')) return 'mdi:credit-card';
      if (m.includes('transferencia') || m.includes('zelle')) return 'mdi:bank-transfer';
      if (m.includes('cachea') || m.includes('cashea')) return 'mdi:lightning-bolt';
      if (m.includes('empresa') || m.includes('corporativo')) return 'mdi:domain';
      return 'mdi:credit-card';
    },
    
    formatNumber(v) { return v === null || v === undefined ? '0.00' : parseFloat(v).toFixed(2); },
    formatFecha(f) { if (!f) return '--/--/----'; return new Date(f).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' }); },
    formatFechaCompleta(fecha) {
      if (!fecha) return '—';
      return new Date(fecha).toLocaleDateString('es-ES', { 
        weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' 
      });
    },

    formatearTipoVentaConCredito(tipo, idTipoCredito) {
      if (!tipo) return 'CONTADO';
      const t = tipo.toString().toUpperCase();
      if (t === 'CREDITO' || t === 'CRÉDITO' || t === '2') {
        const idStr = (idTipoCredito || '').toString().toUpperCase();
        if (idStr.includes('CAS') || idStr.includes('CACHEA')) return 'CASHEA';
        if (idStr.includes('EMP') || idStr.includes('CORP')) return 'EMPRESA';
        return 'CRÉDITO';
      }
      return 'CONTADO';
    },

    formatearMetodoPagoVenta(venta) {
      if (!venta) return '—';
      const mp = venta.metodoPago || venta.tipoPago || venta.tipo_pago || 
                 venta.formaPago || venta.forma_pago || venta.metodo_pago || 
                 venta.idMetodoPago;
      if (mp && mp !== 'Cargando...' && mp !== 'Sin pagos' && mp !== 'Error' && mp !== '—') {
        return mp.toString().toLowerCase();
      }
      const t = (venta.tipoVenta || '').toUpperCase();
      if (t.includes('CREDITO') || t.includes('CRÉDITO')) {
        const idCredito = venta.idTipoCredito || venta.id_tipo_credito || venta.tipoCreditoId;
        const idStr = (idCredito || '').toString().toUpperCase();
        if (idStr === 'CAS-001' || idStr.includes('CACHEA')) return 'CASHEA';
        if (idStr === 'EMPRESA' || idStr === 'CORP' || idStr.includes('EMP')) return 'EMPRESA';
        return 'CRÉDITO';
      }
      if (t.includes('CONTADO')) return 'efectivo';
      return '—';
    },
    
    getEstadoClasses(e) {
      const c = { 
        'Pagada': 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300', 
        'Pendiente': 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-300', 
        'Cancelada': 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300',
        'Completada': 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300',
        'Anulada': 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300',
        'Activa': 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300'
      };
      return c[e] || 'bg-gray-100 text-gray-800';
    },
    
    truncarTexto(t, l) { if (!t) return ''; return t.length <= l ? t : t.substring(0, l) + '...'; },
    sumarPagos(venta) {
      if (!venta.pagos || venta.pagos.length === 0) return 0;
      return venta.pagos.reduce((total, pago) => total + (parseFloat(pago.montoUsd) || 0), 0);
    },
    esVentaCredito(venta) {
      if (!venta.tipoVenta) return false;
      const t = venta.tipoVenta.toString().toLowerCase();
      return t.includes('credito') || t.includes('crédito') || venta.idTipoCredito;
    },
    calcularMetodoPago(v) {
      const vTipo = (v.tipoVenta || '').toUpperCase();
      if (vTipo.includes('CREDITO') || vTipo.includes('CRÉDITO')) {
        const idC = (v.idTipoCredito || v.id_tipo_credito || '').toString().toUpperCase();
        let label = 'CRÉDITO';
        if (idC.includes('CAS') || idC.includes('CACHEA')) label = 'CASHEA';
        else if (idC.includes('EMP') || idC.includes('CORP')) label = 'EMPRESA';
        if (v.pagos && v.pagos.length) {
          const mp = (v.pagos[0]?.tipoPago || 'efectivo').toLowerCase();
          return `${label} + ${mp}`;
        }
        return label;
      }
      if (v.pagos && v.pagos.length) {
        return (v.pagos[v.pagos.length - 1]?.tipoPago || 'efectivo').toLowerCase();
      }
      return 'efectivo';
    },
    
    async cargarVentas() {
      try {
        this.cargando = true;
        await this.cargarPagosCuentaDesdeCache();

        const res = await obtenerVentas();
        if (res.success) {
          this.ventas = (res.data || [])
            .map(v => this.normalizarVenta(v))
            .sort((a, b) => new Date(b.fechaVenta) - new Date(a.fechaVenta));
          this.filtrarVentas();
          this.cargarPagosDeVentas();
        } else {
          this.toast.error(res.error || 'No se pudieron cargar las ventas');
        }
      } catch (e) { 
        console.error(e); 
        this.toast.error('No se pudieron cargar las ventas'); 
      } finally { 
        this.cargando = false; 
      }
    },

    async cargarPagosDeVentas() {
      if (!this.ventas.length) return;
      this.cargandoPagos = true;

      const CONCURRENCIA = 8;
      const ventas = [...this.ventas];
      let idx = 0;
      let totalMatches = 0;

      const worker = async () => {
        while (idx < ventas.length) {
          const v = ventas[idx++];
          try {
            v.cargandoPago = true;
            const res = await obtenerPagosPorVenta(v.idVenta);
            if (res.success && res.data?.length) {
              v.pagos = res.data.map(pago => this.normalizarPago(pago));
            } else {
              v.pagos = [];
            }
            v.metodoPago = this.calcularMetodoPago(v);
            
            // Buscar datos de banco cruzados
            v._bancosInfo = this.buscarTodosBancosInfo(v);
            if (v._bancosInfo.length > 0) totalMatches++;
            
            // Asignar datos a cada pago
            v.pagos.forEach(np => {
              const ref = normStr(np.referencia);
              const pmOp = normStr(np.pmCodigoOperacion);
              
              // Match por referencia y monto
              if (ref) {
                const monto = Math.round((Number(np.montoUsd) || 0) * 100);
                const pc = CACHE_BANCOS.porReferenciaMonto?.[`${ref}|${monto}`];
                if (pc) np._bancosInfo = [pc];
              }
              // Match por código de operación (PM)
              if (!np._bancosInfo.length && pmOp) {
                const pc = CACHE_BANCOS.pagosCuenta?.find(p => normStr(p.pmCodigoOperacion) === pmOp);
                if (pc) np._bancosInfo = [pc];
              }
              
              // FALLBACK: Si no hay bancosInfo, pero el pago trae los datos en sí mismo
              if (!np._bancosInfo.length && (np.referencia || np.pmCodigoOperacion)) {
                np._bancosInfo = [{
                  numeroCuenta: null,
                  referencia: np.referencia,
                  pmCodigoOperacion: np.pmCodigoOperacion,
                  pmBancoEmisorCodigo: np.pmBancoEmisorCodigo || '',
                  bancoNombre: np.bancoNombre || 'Pago Registrado'
                }];
              }
            });

            // Si la venta no tenía _bancosInfo general, pero sus pagos sí, los subimos a la venta
            if (v._bancosInfo.length === 0) {
              const pagosBancos = v.pagos.flatMap(p => p._bancosInfo || []);
              if (pagosBancos.length > 0) {
                v._bancosInfo = pagosBancos;
                totalMatches++;
              }
            }
            
          } catch (e) {
            console.error(`Error cargando pagos para venta ${v.idVenta}:`, e);
            v.pagos = [];
            v.metodoPago = 'Error';
          } finally {
            v.cargandoPago = false;
          }
        }
      };

      try {
        await Promise.all(Array.from({ length: CONCURRENCIA }, worker));
        console.log(`🔎 BANCO CROSS: ${totalMatches}/${ventas.length} ventas con cuenta receptora identificada`);
      } finally {
        this.cargandoPagos = false;
      }
    },
    
    async imprimirVenta(venta) {
      try {
        this.toast.info("Preparando ticket...");
        const tasaRes = await obtenerTasaActiva();
        const tasa = tasaRes.success ? tasaRes.data : null;
        const cliente = this.clientesFullMap.get(venta.idCliente) || { nombre: venta.clienteNombre || '' };
        const usuario = { nombre: venta.vendedorNombre || '' };
        let ventaParaImprimir = { ...venta };
        let productos = venta.detalles || [];
        const fullVentaRes = await obtenerVentaConRelaciones(venta.idVenta);
        if (fullVentaRes.success && fullVentaRes.data) {
          ventaParaImprimir = { ...ventaParaImprimir, ...fullVentaRes.data };
          productos = fullVentaRes.data.ventaDetalles || fullVentaRes.data.detalles || productos;
        }
        imprimirFactura(ventaParaImprimir, cliente, usuario, tasa, productos);
      } catch (error) {
        console.error("Error al imprimir la venta:", error);
        this.toast.error("Error al imprimir el ticket de venta");
      }
    },
    
    async cargarDetallesVenta(venta) {
      try {
        const res = await obtenerVentaConRelaciones(venta.idVenta);
        if (res.success && res.data) {
          venta.detalles = res.data.detalles || [];
          venta.cuotasCredito = res.data.cuotasCredito || [];
          return true;
        }
        return false;
      } catch (e) {
        console.error('Error cargando detalles:', e);
        return false;
      }
    },

    async refreshVentas() { 
      if (this.cargando) return;
      CACHE_BANCOS.pagosCuentaTimestamp = 0;
      await this.cargarVentas(); 
      this.toast.success('Lista actualizada'); 
    },
    
    filtrarVentas() {
      let f = [...this.ventas];
      if (this.filtro.numeroFactura) f = f.filter(v => v.numeroFactura?.toLowerCase().includes(this.filtro.numeroFactura.toLowerCase()));
      if (this.filtro.idCliente) f = f.filter(v => v.idCliente == this.filtro.idCliente);
      if (this.filtro.idVendedor) f = f.filter(v => v.idVendedor == this.filtro.idVendedor);
      if (this.filtro.metodoPago) f = f.filter(v => v.metodoPago === this.filtro.metodoPago);
      if (this.filtro.estado) f = f.filter(v => v.estado === this.filtro.estado);
      const fdStr = this.filtro.fechaDesde;
      const fhStr = this.filtro.fechaHasta;
      if (fdStr && !fhStr) {
        const fd = new Date(fdStr + 'T00:00:00');
        const fh = new Date(fdStr + 'T23:59:59');
        f = f.filter(v => {
          const vDate = new Date(v.fechaVenta);
          return vDate >= fd && vDate <= fh;
        });
      } else {
        if (fdStr) { 
          const fd = new Date(fdStr + 'T00:00:00'); 
          f = f.filter(v => new Date(v.fechaVenta) >= fd); 
        }
        if (fhStr) { 
          const fh = new Date(fhStr + 'T23:59:59'); 
          f = f.filter(v => new Date(v.fechaVenta) <= fh); 
        }
      }
      this.ventasFiltradas = f; this.paginaActual = 1;
    },
    
    toggleFiltros() { this.mostrarFiltros = !this.mostrarFiltros; },
    resetFiltros() { 
      const today = new Date().toLocaleDateString('sv-SE');
      this.filtro = { 
        numeroFactura: '', idCliente: '', idVendedor: '', metodoPago: '', estado: '',
        fechaDesde: today, fechaHasta: '' 
      }; 
      this.filtrarVentas(); 
      this.paginaActual = 1; 
      this.toast.info('Filtros limpiados'); 
    },
    aplicarFiltrosRapidos() { this.filtrarVentas(); this.mostrarFiltros = false; this.toast.success('Filtros aplicados'); },
    paginaAnterior() { if (this.paginaActual > 1) { this.paginaActual--; window.scrollTo({ top: 0, behavior: 'smooth' }); } },
    paginaSiguiente() { if (this.paginaActual < this.totalPaginas) { this.paginaActual++; window.scrollTo({ top: 0, behavior: 'smooth' }); } },
    irAPagina(p) { if (p >= 1 && p <= this.totalPaginas) { this.paginaActual = p; window.scrollTo({ top: 0, behavior: 'smooth' }); } },
    
    async verDetalles(v) {
      this.ventaSeleccionada = { ...v };
      await this.cargarDetallesVenta(this.ventaSeleccionada);
      this.ventaSeleccionada._bancosInfo = this.buscarTodosBancosInfo(this.ventaSeleccionada);
      this.tabActiva = 'resumen';
      this.modalDetalles.show = true;
    },
    cerrarModalDetalles() { 
      this.modalDetalles.show = false; 
      if (this._timerDetalles) clearTimeout(this._timerDetalles);
      this._timerDetalles = setTimeout(() => { this.ventaSeleccionada = null; }, 300); 
    },
    
    abrirModalPago(venta) { this.ventaParaPago = venta; this.modalPago.show = true; },
    cerrarModalPago() { this.modalPago.show = false; this.ventaParaPago = null; },
    
    async confirmarPago() {
      if (!this.ventaParaPago) return;
      this.procesandoPago = true;
      try {
        const res = await actualizarVenta(this.ventaParaPago.idVenta, { 
          ...this.ventaParaPago, estado: 'Pagada' 
        });
        if (res.success) {
          await this.cargarVentas();
          if (this.ventaSeleccionada?.idVenta === this.ventaParaPago.idVenta) this.ventaSeleccionada.estado = 'Pagada';
          this.cerrarModalPago();
          this.toast.success('Venta marcada como pagada');
          notificarVenta('Pago confirmado', `Venta ${this.ventaParaPago?.numeroFactura}`, `Cliente: ${this.ventaParaPago?.clienteNombre || ''}`);
        } else throw new Error(res.error);
      } catch (e) { 
        console.error(e);
        this.toast.error('No se pudo actualizar'); 
      } finally { 
        this.procesandoPago = false; 
      }
    },
    
    abrirModalEliminar(venta) { this.ventaParaEliminar = venta; this.modalEliminar.show = true; },
    cerrarModalEliminar() { this.modalEliminar.show = false; this.ventaParaEliminar = null; },
    
    async confirmarEliminar() {
      if (!this.ventaParaEliminar) return;
      this.procesandoEliminar = true;
      try {
        const res = await eliminarVentaApi(this.ventaParaEliminar.idVenta);
        if (res.success) {
          if (this.modalDetalles.show && this.ventaSeleccionada?.idVenta === this.ventaParaEliminar.idVenta) this.cerrarModalDetalles();
          await this.cargarVentas();
          this.cerrarModalEliminar();
          this.toast.success('Venta eliminada correctamente');
          notificarVenta('Eliminada', `Venta ${this.ventaParaEliminar?.numeroFactura}`, `Cliente: ${this.ventaParaEliminar?.clienteNombre || ''}`);
        } else throw new Error(res.error);
      } catch (e) { 
        this.toast.error(e.message || 'No se pudo eliminar'); 
      } finally { 
        this.procesandoEliminar = false; 
      }
    }
  }
};
</script>

<style scoped>
.text-lexend { font-family: 'Lexend', sans-serif; }
.custom-scrollbar::-webkit-scrollbar { width: 6px; height: 6px; }
.custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
.custom-scrollbar::-webkit-scrollbar-thumb { background: #e2e8f0; border-radius: 10px; }
.dark .custom-scrollbar::-webkit-scrollbar-thumb { background: #334155; }
.dark select option { background-color: #1f2937; color: #ffffff; }
@keyframes zoomIn { from { opacity: 0; transform: scale(0.95); } to { opacity: 1; transform: scale(1); } }
.animate-zoomIn { animation: zoomIn 0.2s ease-out; }
@keyframes fadeInUp { from { opacity: 0; transform: translateY(15px); } to { opacity: 1; transform: translateY(0); } }
.animate-fadeInUp { animation: fadeInUp 0.4s ease-out forwards; }
.delay-100 { animation-delay: 0.1s; }
@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
.animate-fadeIn { animation: fadeIn 0.3s ease-out; }
.transition-all { transition: all 0.3s ease; }
html { scroll-behavior: smooth; }
@media (max-width: 640px) { button { min-height: 44px; min-width: 44px; } }
</style>